import { UserOutlined } from "@ant-design/icons"
import { Select, type SelectProps } from "components/Select/Select"
import { AdminCareOrganization } from "interface/careOrganization"
import { AdminUser } from "interface/user"
import { memo, useMemo } from "react"
import { useAdminCareOrganizationProviders } from "services/organizations"

export const SelectProvider = memo(function SelectProvider({
	careOrganizationId,
	...props
}: SelectProps<AdminUser["id"]> & {
	careOrganizationId: AdminCareOrganization["id"]
}) {
	const { data = [], isFetching } =
		useAdminCareOrganizationProviders(careOrganizationId)
	const options = useMemo(
		() =>
			data.map(({ id, fullName }) => ({
				value: id,
				label: fullName,
			})),
		[data],
	)

	return (
		<Select<AdminUser["id"]>
			{...props}
			virtual={false}
			loading={isFetching}
			showSearch={{ optionFilterProp: "label" }}
			options={options}
			prefix={<UserOutlined aria-hidden />}
		/>
	)
}) as <T = AdminUser["id"]>(
	props: SelectProps<T> & { careOrganizationId: AdminCareOrganization["id"] },
) => React.ReactNode
